

<template>
  <app-text-input
      v-bind="$attrs"
      v-on="{...$listeners}"
      :counter="false"
      :name="name"
      :prepend-icon="prependIcon"
      :rules="getRules"
      :value="computedinputValue"
      readonly
      :force-clearable="clearable"
      @click="click"
  >
    <v-dialog
        ref="hijridialog"
        v-model="modal"
        v-bind="$attrs"
        :max-width="maxWidth"
        :return-value.sync="inputValue"
        :width="width"
        persistent
    >
      <v-hijri-date-picker
          v-model="inputValue"
          v-bind="$attrs"
          scrollable
      >
        <app-btn
            color="primary"
            text
            @click="save(inputValue)"
        >
          {{ $t('done') }}
        </app-btn>
        <v-spacer></v-spacer>
        <app-btn
            color="primary"
            text
            @click="cancel"
        >
          {{ $t('cancel') }}
        </app-btn>
      </v-hijri-date-picker>
    </v-dialog>
  </app-text-input>
</template>

<script>

import TextInput from './TextInput';
import VHijriDatePicker from 'vuetify-umalqura'
import moment from "moment-hijri";

export default {
  name: 'HijriDatePicker',
  extends: TextInput,
  components: {
    VHijriDatePicker
  },
  props: {
    maxWidth: {
      type: [String, Number],
      default: () => 290
    },
    width: {
      type: [String, Number],
      default: () => 290
    },
    prependIcon: {
      type: String,
      default: () => 'event'
    },
    clearable: {
      type: Boolean,
      default: () => !0
    },
    readonly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      modal: false
    };
  },
  methods: {
    input($event) {
      this.$emit('input', $event);
    },
    save(v) {
      this.$refs.hijridialog.save(v);
      this.input(v);
      this.$emit('change');
    },
    click() {
      if(this.readonly === true) return;
      this.modal = !this.modal;
    },
    cancel() {
      this.modal = !1;
    }
  },
  computed:{
    computedinputValue() {
      return this.inputValue ? this.$helpers.fromArabicNumber(moment(this.inputValue,'iYYYY-iM-iD').format('iDD-iMM-iYYYY')) : '';
    },
    inputValue:{
      set(n){
        this.$emit('input',n);
        this.$emit('update',n);
      },
      get(){
        return this.value;
      }
    }
  },
  mounted() {
    this.inputValue = this.value;
  }
};
</script>
